import { render, staticRenderFns } from "./FooterLogo.vue?vue&type=template&id=2cf777aa&scoped=true&"
import script from "./FooterLogo.vue?vue&type=script&lang=js&"
export * from "./FooterLogo.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogo.vue?vue&type=style&index=0&id=2cf777aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf777aa",
  null
  
)

export default component.exports